<template>
    <component 
        :is="((this.$route.meta.toolbar)||'BaseToolbar')" 
        :props="props">
    </component>
</template>
<script>
    import { BaseToolbar } from './toolbars'

    export default {
        components: {
           BaseToolbar
        }
    }
</script>